import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import './App.css';
import BrowserViewer from './BrowserViewer';
import Login from './components/Login';
import './aws-config';
import './axios-config';
import ProtectedRoute from './ProtectedRoute';
import ModuleSelector from './components/ModuleSelector';

function App() {
  return (
    <Routes>
      {/*<Route path="/sign-up" element={<SignUp />} />*/}
      <Route path="/login" element={<Login />} />
      <Route element={<ProtectedRoute />}>
        <Route path="/module-list" element={<ModuleSelector />} />
        <Route path="/module/:moduleId" element={<BrowserViewer />} />
        <Route path="*" element={<Navigate to="/module-list" replace />} />
      </Route>
    </Routes>
  );
}

export default App;
